function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(32,173,155,0.49);}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M32.016,12.328,25.473,5.784H2.571V48.316H54.918V12.328ZM28.744,23.779,40.2,35.229H32.016V48.316H25.473V35.229H17.293Z",
  transform: "translate(-2.571 -5.784)"
});

const SvgIconUpload = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52.347,
    height: 42.532,
    viewBox: "0 0 52.347 42.532",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconUpload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Upload.02d5b130.svg";
export { ForwardRef as ReactComponent };